import { HTTPClient } from "./Client";

const FrequenciaApi = {
    async adicionarFrequenciasAsync(turmaId, dataPresenca, frequencias) {

        console.log(frequencias)
        await HTTPClient.post(`/Frequencia/AdicionarFrequencias/${turmaId}/${dataPresenca}`, frequencias);
    },

    async atualizarFrequenciasAsync(turmaId, dataPresenca, dataEntrada, dataSaida, pessoaId) {
        const atualizarFrequencia = {
            TurmaId: turmaId,
            DataPresenca: dataPresenca,
            DataEntrada: dataEntrada,
            DataSaida: dataSaida,
            PessoaId: pessoaId
        }
        await HTTPClient.put(`/Frequencia/AtualizarFrequencia`, atualizarFrequencia);
    },

    async obterFrequenciaPorIdAsync(frequenciaId) {

        const response = await HTTPClient.get(`/Frequencia/ObterFrequenciaPorId/${frequenciaId}`);
        return response.data;
    },

    async listarInformacoesFrequenciasAsync(turmaId, dataP) {
        const dataPresenca = new Date(dataP).toISOString().split("T")[0];

        const response = await HTTPClient.get(`/Frequencia/ListarInformacoesFrequencias/${turmaId}/${dataPresenca}`);

        return response?.data;
    },

    async listarHorasTurmasFrequenciasAsync(turmaId, datainicio, datafim) {

        const response = await HTTPClient.get(`/Frequencia/ListarHorasTurmasFrequencia/${turmaId}/${datainicio}/${datafim}`);

        return response?.data;
    },
    async ListarHorasTurmasPorDiaFrequencia(turmaId, mes, ano) {

        const response = await HTTPClient.get(`/Frequencia/ListarHorasTurmasPorDiaFrequencia/${turmaId}/${mes}/${ano}`);

        return response?.data;
    },

    async ListarFrequenciaTodosAlunos(turmaId, dataFormatada) {
        // A data já chega formatada, não precisa formatar de novo!
        const response = await HTTPClient.get(`/Frequencia/ListarFrequenciaTodosAlunos/${turmaId}/${dataFormatada}`);
        return response?.data;
    },

    async obterHorasFrequencias() {
        const response = await HTTPClient.get(`/Frequencia/CalcularHorasFrequenciasTotalMensalSemanal`);
        return response.data;
    }

}

export default FrequenciaApi;